import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import SiteHeader from '../Site/SiteHeader.js';
import HomeBanner from './HomeBanner.js';
import PoetList from './PoetList.js';
import HomeWhy from './HomeWhy.js';
import SiteFooter from '../Site/SiteFooter.js';
import jumbotron from '../../images/bookheart_medium_text.jpg';




class Home extends Component {

  state = {
    imageLoaded: false,
    display: "none"
  }

  componentWillMount() {
    document.title = 'Close Reading - Learn to Love Poetry';
    this.props.fetchHomePoets();
    this.props.fetchUser();
  }

  renderBanner(){
    if(this.props.home.user === false)
      return <HomeBanner />
  }

  handleOnLoad(){
    this.setState({imageLoaded: true, display: "block"});
  }

  //For jumbotron on load
  Placeholder = (props) => (
    <img alt="Learn to Love Poetry" id="home-jumbotron" src='data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve" height="402px" width="1000px"></svg>' />
  )

  render() {
    if(!this.props.home.poets)
      return null;
    return (
      <React.Fragment>
        <SiteHeader logOut = {this.props.logOut} home={this.props.home} fetchUser={this.props.fetchUser}/>
        <div style={{overflow: 'hidden'}} >
          <img alt="Learn to Love Poetry"
            id="home-jumbotron"
            src={jumbotron}
            style={{display: this.state.display}}
            onLoad={this.handleOnLoad.bind(this)} />
          {!this.state.imageLoaded && <this.Placeholder />}
        </div>
        {this.renderBanner()}
        <PoetList heading = "Featured Poets" poets = {this.props.home.poets}/>
        <HomeWhy />
        <SiteFooter />
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    home: state.home
  };
}

export default connect(mapStateToProps, actions)(Home);



// WEBPACK FOOTER //
// ./src/components/Home/Home.js